'use strict';
import EqualHeight from '../../../src/js/shared/equalHeight';

const $ = jQuery.noConflict();

$(function() {
	const stickyStack = {
		$links: null,
		$spots: null,
		activeId: null,
		offset: 0,

		init: function() {
			EqualHeight.init();

			this.$links = $('.js-sticky-nav-link');
			this.$spots = $('.js-sticky-spot');
			if (!this.$spots.length) return;

			this.updateOffset(); // compute sticky top offset from CSS
			this.checkActive(); // initial state

			// Scroll + resize listeners
			window.addEventListener('scroll', this.throttle(() => this.checkActive(), 60), {passive: true});
			window.addEventListener('resize', this.throttle(() => {
				this.updateOffset();
				this.checkActive();
			}, 120));
		},

		/**
		 * Read the same offset the sticky rows use in CSS (`top`).
		 * This defines the “activation line” where a section becomes active.
		 */
		updateOffset: function() {
			const row = document.querySelector('.js-sticky-stack-row');
			this.offset = row ? parseInt(getComputedStyle(row).top, 10) || 0 : 0;
		},

		checkActive: function() {
			let currentId = null;

			// Find the last spot whose top <= activation line
			this.$spots.each((i, el) => {
				const top = el.getBoundingClientRect().top;
				if (top <= this.offset + 1) currentId = '#' + el.id;
			});

			// Fallback to the first spot if we're above everything
			if (!currentId && this.$spots.length) {
				currentId = '#' + this.$spots.first().attr('id');
			}

			if (currentId && currentId !== this.activeId) {
				this.activeId = currentId;
				this.setActive(currentId);
			}
		},

		setActive: function(id) {
			this.$links.each((_, link) => {
				link.classList.toggle('is-active', link.getAttribute('href') === id);
			});
		},

		throttle: function(fn, wait = 100) {
			let t;
			let last = 0;
			return (...args) => {
				const now = Date.now();
				if (now - last >= wait) {
					last = now;
					fn.apply(this, args);
				} else {
					clearTimeout(t);
					t = setTimeout(() => { last = Date.now(); fn.apply(this, args); }, wait - (now - last));
				}
			};
		}
	};

	stickyStack.init();
});
